module.exports = __webpack_public_path__ + "static/media/target-white.a5f59e65.svg";